// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"de719381","515":"bc805476","741":"b5f91245"}[chunkId] + ".chunk.js";
};